import React, { useEffect, useState } from "react";
import Storage from "../../../storage";
import Constants from "../../../constants";
import Axios from "axios";
import { Redirect } from "react-router-dom";
import { GetHoldingTableStatus } from "../Util/pmsIntegrationApiUtil";
import { Button, Grid, Snackbar, TextField } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert"
import MaterialDataGrid from "../Components/Common/MaterialDataGrid";
import { ColumnFilter, HoldingTableColumns } from "./HoldingTableColumns";
import { useUIContext } from "../../../ContextLib/contextHooks";
import PreviewData from "./HoldingTableDialogs";

export default function HoldingTableStatus() {
  const ui = useUIContext("HoldingTableStatus");
  const [today] = useState(new Date().toISOString().split("T")[0])
  const [logs, setLogs] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewData, setPreviewData] = useState(null)
  const [filteredLogs, setFilteredLogs] = useState(null)
  const [levelFilter, setLevelFilter] = useState('');
  const [classFilter, setClassFilter] = useState('');
  const [memberFilter, setMemberFilter] = useState('');
  const [machineFilter, setMachineFilter] = useState('');
  const [searchFilter, setSearchFilter] = useState('');
  const [startDateFilter, setStartDateFilter] = useState(today);
  const [endDateFilter, setEndDateFilter] = useState(today);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [SnackbarMessage, setSnackbarMessage] = useState('');
  const [errorSeverity, setErrorSeverity] = useState('success');
  const getHoldingTableStatus = async (StartDate, EndDate) => {
    ui.ShowOverlay()
    try {
      const startDate = `${StartDate}T00:00:00`
      const endDate = `${EndDate}T23:59:59`
      const response = await GetHoldingTableStatus(startDate, endDate)
      setLogs(response.data.map(item => ({ ...item, date: new Date(item.date).toLocaleString("en-US") })))
    }
    catch (reason) {
      ShowSnackBar("error", reason)
      setLogs([])
    }
    finally {
      ui.HideOverlay()
    }
  }
  const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  };
  const ShowSnackBar = (severity, message) => {
    setErrorSeverity(severity)
    setSnackbarMessage(message)
    setOpenSnackBar(true)
  }

  const onSelectedCell = (data) => {
    setPreviewData(data.row)
    setPreview(true)
  }

  useEffect(() => {
    const componentDidMount = async () => {
      const user = Storage.getItem(Constants.currUserKey);
      let redirectToLogin = false;
      if (user && user.jwt) {
        try {
          const jwtCheckUrl = `${process.env.REACT_APP_ADMIN_API}/jwtCheck`;
          await Axios.get(jwtCheckUrl);
        } catch (error) {
          redirectToLogin = true;
        }
      } else {
        redirectToLogin = true;
      }
      if (redirectToLogin) return <Redirect to={{ pathname: '/' }} />;
    };
    componentDidMount();
    getHoldingTableStatus(startDateFilter, endDateFilter);
  }, []);
  useEffect(() => {
    const filters = {
      levelFilter,
      classFilter,
      memberFilter,
      machineFilter,
      searchFilter
    }

    const filterMap = {
      levelFilter: 'level',
      classFilter: 'className',
      memberFilter: 'memberName',
      machineFilter: 'machineName',
      searchFilter: ['message', 'id', 'exception'],
    };

    const applyFilters = () => logs.filter((log) => Object.entries(filters).every(([key, value]) => {
      if (!value) return true;
      if (key !== 'searchFilter') {
        const logKey = filterMap[key]
        return log[logKey]?.toString().toLowerCase().includes(value.toLowerCase());
      }
      else {
        const logKeys = filterMap[key]
        return logKeys.some((logKey) =>
          log[logKey]?.toString().toLowerCase().includes(value.toLowerCase())
        );
      }
    }));

    const emptyFilters = Object.values(filters).every(value => value === '')
    if (emptyFilters)
      setFilteredLogs(null)
    else
      setFilteredLogs(applyFilters())
  }, [
    logs,
    levelFilter,
    classFilter,
    memberFilter,
    machineFilter,
    searchFilter
  ])
  return (
    <>
      <h1 className="pmstitle-title__wrapper">Holding Table Status</h1>
      <Grid container spacing={2} alignItems="center">
        <Grid item container alignItems="center" style={{ gap: "16px" }}>
          <Grid container alignItems="center" direction="row" style={{ gap: "8px" }}>
            <TextField
              variant="outlined"
              size="small"
              value={searchFilter}
              style={{ flex: 1 }}
              onChange={(event) => setSearchFilter(event.target.value)}
              label="Type here to search for Message/ID/Exception"
              InputLabelProps={{ shrink: true }} />
            <TextField
              type="date"
              variant="outlined"
              size="small"
              label="Start Date"
              value={startDateFilter}
              onChange={(event) => {
                const value = event.target.value
                const newStart = value
                let newEnd = endDateFilter
                if (value > endDateFilter) {
                  newEnd = value
                  setEndDateFilter(newEnd)
                }
                setStartDateFilter(newStart)
              }}
              InputLabelProps={{ shrink: true }}
              inputProps={{ max: today }}
              style={{ minWidth: "160px" }} />
            <TextField
              type="date"
              variant="outlined"
              size="small"
              label="End Date"
              value={endDateFilter}
              onChange={(event) => {
                const value = event.target.value
                let newStart = startDateFilter
                const newEnd = value
                if (value < startDateFilter) {
                  newStart = value
                  setStartDateFilter(newStart)
                }
                setEndDateFilter(newEnd)
              }}
              InputLabelProps={{ shrink: true }}
              inputProps={{ max: today }}
              style={{ minWidth: "160px" }} />
            <Button
              variant="contained"
              color="primary"
              onClick={() => getHoldingTableStatus(startDateFilter, endDateFilter)}
            >
              Search
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setFilteredLogs(null)
                setLevelFilter('')
                setClassFilter('')
                setMemberFilter('')
                setMachineFilter('')
                setSearchFilter('')
              }}
            >
              Clear Filters
            </Button>
          </Grid>
          <Grid container alignItems="center" style={{ gap: "8px" }}>
            <ColumnFilter
              label="Level"
              handler={setLevelFilter}
              value={levelFilter}
              options={[...new Set((filteredLogs ?? logs).map(item => item.level))]}
            />
            <ColumnFilter
              label="Class Name"
              handler={setClassFilter}
              value={classFilter}
              options={[...new Set((filteredLogs ?? logs).map(item => item.className))]}
            />
            <ColumnFilter
              label="Member Name"
              handler={setMemberFilter}
              value={memberFilter}
              options={[...new Set((filteredLogs ?? logs).map(item => item.memberName))]}
            />
            <ColumnFilter
              label="Machine Name"
              handler={setMachineFilter}
              value={machineFilter}
              options={[...new Set((filteredLogs ?? logs).map(item => item.machineName))]}
            />
          </Grid>
        </Grid>
        <Grid item lg>
          <MaterialDataGrid
            onSelectedCell={onSelectedCell}
            tableHeight="60dvh"
            tableColumns={HoldingTableColumns}
            tableData={filteredLogs ?? logs}
            showBorder={true}
          />
        </Grid>
      </Grid>
      {preview && <PreviewData open={preview} openHandler={setPreview} data={previewData} dataHandler={setPreviewData} />}
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openSnackBar} autoHideDuration={3000} onClose={() => setOpenSnackBar(false)}>
        <Alert onClose={() => setOpenSnackBar(false)} severity={errorSeverity}>
          {SnackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
